import { queryOptions, useQuery } from '@tanstack/react-query'
import { getTestimonials } from '../services/getTestimonials.service'
import { testimonialsKeys } from '../constants/testimonials.queryKeys'

export const testimonialsQueryOptions = () =>
  queryOptions({
    queryKey: testimonialsKeys.list(),
    queryFn: getTestimonials,
    staleTime: 5 * 60 * 1000,
  })

export function useTestimonials() {
  return useQuery(testimonialsQueryOptions())
}
